import { TFooterType } from '../../types/footerType';

const defaultState: TFooterType = 'desktop';

export function footerTypeReducer(state: TFooterType = defaultState): TFooterType {
  return state;
}
